module.exports = __webpack_public_path__ + "img/03.14617ccf.jpg";